import CarRentals from "pages/CarRentals";

export default function CarRentalsPage() {
  return <CarRentals />;
}
